module.exports = __webpack_public_path__ + "static/media/hero-desktop.e8a5ee65.jpg";